import { useEffect, useState, useRef } from "react";
import Button from "../../Button/Button";
import axios from "axios";
import Plus from "../../picture/plus-btn.png";
import Send from "../../picture/Send.png";
import NextLanguage from "../../picture/NextLanguage.png";
import timerLanguage from "../../picture/timer-language.png";
import "./languageFlag.css";
import { useGlobalContext } from "../../Context/Context";

const LanguageFlagNew = ({
  setCurrentPage,
  setCurrentPageGlobal,
  setSelectAccount,
  selectedCountry,
  setSelectedCountry,
}) => {
  const [flags, setFlags] = useState([]);
  const baseUrl = "https://data.nadzor.app/api";

  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const [widthFlag, setWidthFlag] = useState();
  const [heightFlag, setHeightFlag] = useState();
  const [clickedNext, setClickedNext] = useState(false);

  let counter = 0;
  const [visibilityCounter, setVisibilityCounter] = useState(counter);
  const [isTimerReset, setIsTimerReset] = useState(false);
  const [isLandscape, setIsLandscape] = useState(
    window.innerWidth >= window.innerHeight
  );
  const interval = useRef();
  const timeoutReset = useRef();
  const changeFlagInterval = useRef();
  const { loggedUser, apiKey, setSelectedLanguage } = useGlobalContext();
  const { typeButton } = useGlobalContext();

  const addNewLanguage = () => {
    if (loggedUser !== undefined) {
      setCurrentPage(1);
    } else {
      setCurrentPage(5);
    }
  };

  const handleSelectFlag = (country) => {
    setSelectedCountry(country);
    document.querySelector(".reset-timer-span").style.display = "none";
    clearTimeout(timeoutReset.current);
    console.log("Brise se interval", interval);
    clearTimeout(interval.current);
    console.log("Zemlja brise interval", country);
  };

  const handleSelectLanguage = async (e) => {
    let customBtn;

    if (e !== undefined) {
      customBtn = e.currentTarget.firstChild;
      customBtn.classList.add(
        selectedCountry.percentage > 30.0 ? "correct" : "not-correct"
      );
    }
    if (selectedCountry === undefined || selectedCountry.percentage > 30.0) {
      console.log("Ime prosledjenog jezika", selectedCountry);
      let languageCurrent = JSON.parse(localStorage.getItem("select-language"));
      if (languageCurrent === null)
        languageCurrent = {
          name: "English",
        };
      console.log(languageCurrent);
      try {
        const { data } = await axios.post(`${baseUrl}/vocabulary/getAll.php`, {
          lang_name:
            selectedCountry === undefined
              ? languageCurrent.name
              : selectedCountry.lang_name,
        });
        console.log(data);
        if (data.status === 200) {
          setSelectedLanguage(data);
          localStorage.setItem("select-language", JSON.stringify(data));
          if (loggedUser === undefined) {
            console.log("Poziva se za unos drugog jezika", data);
            const item = flags.find(
              (flag) =>
                flag.lang_name ===
                (selectedCountry === undefined
                  ? languageCurrent.name
                  : selectedCountry.lang_name)
            );
            handleSelectFlag(item);

            interval.current = setTimeout(() => {
              if (selectedCountry !== undefined)
                customBtn.classList.remove("correct");
              setCurrentPageGlobal(2);
            }, 500);
          } else {
            setSelectAccount(0);
            let sidebar = document.querySelector(".sidebar");
            sidebar.style.pointerEvents = "auto";
            let definePin = document.querySelector(".definePin-container");
            definePin.style.width = "calc(100vw -11.11vh)";
          }
        } else {
          customBtn.classList.remove("correct");
        }
      } catch (error) {
        console.log(error);
        if (customBtn !== null) customBtn.classList.remove("correct");
      }
    } else {
      const intervalNotCorrect = setTimeout(() => {
        customBtn.classList.remove("not-correct");
        clearInterval(intervalNotCorrect);
      }, 500);
    }
  };

  const handleNextSelectLanguage = async () => {
    const languageCurrent = JSON.parse(localStorage.getItem("select-language"));
    console.log(languageCurrent);
    try {
      const { data } = await axios.post(`${baseUrl}/vocabulary/getAll.php`, {
        lang_name: languageCurrent === null ? "English" : languageCurrent.name,
      });
      console.log(data);
      if (data.status === 200) {
        setSelectedLanguage(data);
        localStorage.setItem("select-language", JSON.stringify(data));
        if (loggedUser === undefined) {
          console.log("Poziva se za unos drugog jezika", data);
          console.log(flags);
          const item = flags.find(
            (flag) => flag.lang_name === languageCurrent.name
          );
          handleSelectFlag(item);
          setClickedNext(true);
          interval.current = setTimeout(() => {
            setCurrentPageGlobal(2);
          }, 500);
        } else {
          setSelectAccount(0);
          let sidebar = document.querySelector(".sidebar");
          sidebar.style.pointerEvents = "auto";
          let definePin = document.querySelector(".definePin-container");
          definePin.style.width = "calc(100vw -11.11vh)";
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("Izabran jezik:");
    if (isTimerReset) {
      setVisibilityCounter(counter);
      setIsTimerReset(false);
    } else
      timeoutReset.current = setTimeout(() => {
        setVisibilityCounter(visibilityCounter + 1);
      }, 1000);

    if (visibilityCounter === 5 && !isTimerReset) handleSelectLanguage();
  }, [visibilityCounter, isTimerReset]);

  useEffect(() => {
    if (
      selectedCountry !== undefined &&
      (visibilityCounter === 5 || clickedNext)
    )
      document.querySelector(
        isLandscape
          ? ".select-country-button-landscape"
          : ".select-country-button"
      ).style.display = "none";
  }, [selectedCountry]);

  const resetTimer = () => {
    if (selectedCountry !== undefined) return;
    clearTimeout(timeoutReset.current);
    setIsTimerReset(true);
  };

  const detailedView = () => {
    let flag = document.querySelector(
      window.innerWidth > window.innerHeight
        ? ".flags-up-landscape"
        : ".flags-up"
    );
    // console.log(flag);
    // console.log(isLandscape);
    if (flag !== null) {
      if (window.innerWidth > window.innerHeight) {
        setWidth(flag.getBoundingClientRect().width);
        setHeight(flag.getBoundingClientRect().height);
        setWidthFlag(0.2 * flag.getBoundingClientRect().width);
        setHeightFlag(0.2 * flag.getBoundingClientRect().width);
      } else {
        setWidth(flag.getBoundingClientRect().width);
        setHeight(flag.getBoundingClientRect().height);
        setWidthFlag(0.12 * flag.getBoundingClientRect().width);
        setHeightFlag(0.12 * flag.getBoundingClientRect().width);
      }
    }
    setIsLandscape(window.innerWidth > window.innerHeight);
  };

  const animatedFlags = () => {
    console.log("Animiranje zastava");
    if (flags.length === 0) return;
    const flagsUp = document.querySelectorAll(".one-flag-up");
    const flagsMid = document.querySelectorAll(".one-flag");
    const flagsDown = document.querySelectorAll(".one-flag-down");
    const allFlags = [...flagsUp, ...flagsMid, ...flagsDown];
    // flag.percent float sa jednom decimalom
    const someFlags = flags.filter((flag) => flag.percentage > 30.0);
    let someFlagsDiv = [];
    someFlags.forEach((flag) => {
      const curFlag = allFlags.find((f) => f.id === flag.language_id);
      someFlagsDiv.push(curFlag);
    });
    let currentIndex = -1;
    let timeout;
    function animateImage() {
      if (currentIndex === someFlagsDiv.length) return;
      currentIndex = (currentIndex + 1) % (someFlagsDiv.length + 1);
      console.log(someFlagsDiv[currentIndex]);
      if (currentIndex < someFlagsDiv.length)
        someFlagsDiv[currentIndex].style.animationPlayState = "paused";
      if (currentIndex < someFlagsDiv.length)
        someFlagsDiv[currentIndex].style.animationPlayState = "running";
      timeout = setTimeout(() => {
        if (currentIndex < someFlagsDiv.length) {
          someFlagsDiv[currentIndex].style.animation = "animationFlag";
          someFlagsDiv[currentIndex].style.animationDuration = "1s";
        }
        animateImage();
      }, 1000);
    }
    setInterval(() => {
      clearTimeout(timeout);
      console.log("Opet se animira");
      currentIndex = -1;
      animateImage();
    }, (someFlagsDiv.length + 1) * 1000);
    animateImage();
  };

  window.addEventListener("resize", detailedView);

  useEffect(() => {
    console.log("POziva se useEffect");
    const handleSetFlags = async () => {
      try {
        const { data } = await axios.get(
          `${baseUrl}/languages/ReadMainLanguages.php`,
          {}
        );
        console.log(data);
        if (data.status === 200) {
          setFlags(data.data);
          detailedView();
        }
      } catch (error) {
        console.log(error);
      }
    };

    handleSetFlags();

    console.log("Interval postavljen", interval);
    return () => clearTimeout(interval.current);
  }, []);

  useEffect(() => {
    if (flags.length === 0) return;
    animatedFlags();
    if (loggedUser !== undefined) {
      let sidebar = document.querySelector(".sidebar");
      if (sidebar.classList.contains("visible")) {
        sidebar.classList.replace("visible", "hidden");
        sidebar.style.pointerEvents = "none";
        let definePin = document.querySelector(".definePin-container");
        definePin.style.width = "100vw";
        console.log("Postavljen novi css", sidebar);
      }
    }
  }, [flags]);

  return !isLandscape ? (
    <>
      <div className="wrapper-languages-container">
        <div className="flags-up">
          {flags.map((item, index) => {
            if (index < Math.floor(flags.length / 4)) {
              const theta = Math.PI / Math.floor(flags.length / 4 + 1);

              const circleRadiusX = width / 2 - width / 8;
              const x =
                circleRadiusX * Math.cos(theta * (index + 1)) +
                width / 2 -
                widthFlag / 2;

              const y =
                circleRadiusX * Math.sin(theta * (index + 1)) -
                circleRadiusX / 3;
              return (
                <div
                  key={item.language_id}
                  className="one-flag-up"
                  id={item.language_id}
                  onClick={() => {
                    clearTimeout(changeFlagInterval.current);
                    handleSelectFlag(item, index);
                  }}
                  style={{
                    bottom: `${y}px`,
                    right: `${x}px`,
                    width: `${widthFlag}px`,
                    height: `${heightFlag}px`,
                  }}
                >
                  <img src={item.lang_flag_base64} alt="" />
                </div>
              );
            }
          })}
        </div>
        <div className="flags-center">
          <div className="flags-center-side-left">
            {flags.map((item, index) => {
              const numberOfFlags = Math.round(flags.length / 4);
              // if (index >= flags.length / 4 && index < flags.length / 2) {
              if (
                index >= flags.length - numberOfFlags &&
                index < flags.length
              ) {
                // let distance = ((90*window.innerHeight/2)/200)/(flags.length/4) + 30
                return (
                  <div
                    key={item.language_id}
                    className="one-flag"
                    id={item.language_id}
                    onClick={() => {
                      clearTimeout(changeFlagInterval.current);
                      handleSelectFlag(item, index);
                    }}
                    style={{
                      width: `${widthFlag}px`,
                      height: `${heightFlag}px`,
                    }}
                  >
                    <img src={item.lang_flag_base64} alt="" />
                  </div>
                );
              }
            })}
          </div>
          {selectedCountry !== undefined && (
            <div className="wrapper-select-flag">
              <img
                src={selectedCountry.lang_flag_base64}
                className="image-flag"
              ></img>
              <div className="wrap-language-send">
                <div
                  className="name-country"
                  style={{ fontSize: `${1.2 * widthFlag}px` }}
                >
                  {selectedCountry.lang_name.slice(0, 3).toUpperCase()}
                </div>
                <div className="usage-percentage">
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: `${widthFlag / 2}px`,
                      fontWeight: "600",
                      color:
                        selectedCountry.percentage >= 30.0 ? "black" : "red",
                      opacity: "0.8",
                      marginBottom: "10%",
                    }}
                  >
                    {`${selectedCountry.percentage}%`}
                  </p>
                </div>
                <div
                  className="select-country-button"
                  onClick={(e) => handleSelectLanguage(e)}
                >
                  <Button typeButton={typeButton} activation={true}>
                    <img src={Send} alt="" className="language-selection-img" />
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className="flags-center-side-right">
            {flags.map((item, index) => {
              // if (index >= flags.length / 2 && index < (3 * flags.length) / 4) {
              const numberOfFlags = Math.round(flags.length / 4);
              if (
                index >= Math.floor(flags.length / 4) &&
                index < Math.floor(flags.length / 4) + numberOfFlags
              ) {
                return (
                  <div
                    key={item.language_id}
                    className="one-flag"
                    id={item.language_id}
                    onClick={() => {
                      clearTimeout(changeFlagInterval.current);
                      handleSelectFlag(item, index);
                    }}
                    style={{
                      width: `${widthFlag}px`,
                      height: `${heightFlag}px`,
                    }}
                  >
                    <img src={item.lang_flag_base64} alt="" />
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="flags-down">
          {flags.map((item, index) => {
            const numberOfFlags = Math.round(flags.length / 4);
            // if (index >= (3 * flags.length) / 4 && index < flags.length) {
            if (
              index >= Math.floor(flags.length / 4) + numberOfFlags &&
              index < flags.length - numberOfFlags
            ) {
              const theta = Math.PI / Math.floor(flags.length / 4 + 1);

              const circleRadiusX = width / 2 - width / 8;
              const x =
                circleRadiusX * Math.cos(theta * index + Math.PI / 2) +
                width / 2 -
                widthFlag / 2;

              const y =
                circleRadiusX * Math.sin(theta * index + Math.PI / 2) -
                circleRadiusX / 3;
              // console.log(wrapperWidth);
              // console.log("Element"+index+"has"+ x +"width");
              // console.log("Element"+index+"has"+ y +"height");
              return (
                <div
                  key={item.language_id}
                  className="one-flag-down"
                  id={item.language_id}
                  onClick={() => {
                    clearTimeout(changeFlagInterval.current);
                    handleSelectFlag(item, index);
                  }}
                  style={{
                    top: `${y}px`,
                    left: `${x}px`,
                    width: `${widthFlag}px`,
                    height: `${heightFlag}px`,
                  }}
                >
                  <img src={item.lang_flag_base64} alt="" />
                </div>
              );
            }
          })}
          <div className="flags-down-button" onClick={addNewLanguage}>
            <Button
              typeButton={typeButton}
              activation={false}
              btnId="language-selection-add-button"
            >
              <img src={Plus} alt="" className="language-selection-img" />
            </Button>
          </div>
        </div>
      </div>
      <div className="languages-footer">
        <div className="leftside-languages-footer" onClick={resetTimer}>
          <span
            style={{ fontSize: `${widthFlag / 2}px`, fontWeight: "600" }}
            className={
              visibilityCounter > 3
                ? "reset-timer-span timer-red"
                : "reset-timer-span"
            }
          >
            {visibilityCounter}
          </span>
          <img src={timerLanguage}></img>
        </div>

        <div
          className="rightside-languages-footer"
          onClick={handleNextSelectLanguage}
        >
          <img src={NextLanguage}></img>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="wrapper-languages-container-landscape">
        <div className="flags-up-landscape">
          {flags.map((item, index) => {
            if (index < Math.floor(flags.length / 4)) {
              const theta = Math.PI / Math.floor(flags.length / 4 + 1);

              const circleRadiusX = height / 2 - height / 8;
              const x =
                circleRadiusX * Math.cos(theta * (index + 1)) +
                height / 2 -
                heightFlag / 2;

              const y =
                circleRadiusX * Math.sin(theta * (index + 1)) -
                circleRadiusX / 3;

              return (
                <div
                  key={item.language_id}
                  className="one-flag-up"
                  id={item.language_id}
                  onClick={() => {
                    clearTimeout(changeFlagInterval.current);
                    handleSelectFlag(item, index);
                  }}
                  style={{
                    right: `${y}px`,
                    bottom: `${x}px`,
                    width: `${widthFlag}px`,
                    height: `${heightFlag}px`,
                  }}
                >
                  <img src={item.lang_flag_base64} alt="" />
                </div>
              );
            }
          })}
        </div>
        <div className="flags-center-landscape">
          <div className="flags-center-side-left-landscape">
            {flags.map((item, index) => {
              const numberOfFlags = Math.round(flags.length / 4);
              // if (index >= flags.length / 4 && index < flags.length / 2) {
              if (
                index >= flags.length - numberOfFlags &&
                index < flags.length
              ) {
                // let distance = ((90*window.innerHeight/2)/200)/(flags.length/4) + 30
                return (
                  <div
                    key={item.language_id}
                    className="one-flag"
                    id={item.language_id}
                    onClick={() => {
                      clearTimeout(changeFlagInterval.current);
                      handleSelectFlag(item, index);
                    }}
                    style={{
                      width: `${widthFlag}px`,
                      height: `${heightFlag}px`,
                    }}
                  >
                    <img src={item.lang_flag_base64} alt="" />
                  </div>
                );
              }
            })}
          </div>
          {selectedCountry !== undefined && (
            <div className="wrapper-select-flag-landscape">
              <img
                src={selectedCountry.lang_flag_base64}
                className="image-flag-landscape"
              ></img>
              <div className="wrap-language-send-landscape">
                <div
                  className="name-country-landscape"
                  style={{ fontSize: `${1.2 * widthFlag}px` }}
                >
                  {selectedCountry.lang_name.slice(0, 3).toUpperCase()}
                </div>
                <div className="usage-percentage">
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: `${widthFlag / 2}px`,
                      fontWeight: "600",
                      color:
                        selectedCountry.percentage >= 30.0 ? "black" : "red",
                      opacity: "0.8",
                      marginBottom: "10%",
                    }}
                  >
                    {`${selectedCountry.percentage}%`}
                  </p>
                </div>
                <div
                  className="select-country-button-landscape"
                  onClick={(e) => handleSelectLanguage(e)}
                >
                  <Button typeButton={typeButton} activation={true}>
                    <img src={Send} alt="" className="language-selection-img" />
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className="flags-center-side-right-landscape">
            {flags.map((item, index) => {
              // if (index >= flags.length / 2 && index < (3 * flags.length) / 4) {
              const numberOfFlags = Math.round(flags.length / 4);
              if (
                index >= Math.floor(flags.length / 4) &&
                index < Math.floor(flags.length / 4) + numberOfFlags
              ) {
                return (
                  <div
                    key={item.language_id}
                    className="one-flag"
                    id={item.language_id}
                    onClick={() => {
                      clearTimeout(changeFlagInterval.current);
                      handleSelectFlag(item, index);
                    }}
                    style={{
                      width: `${widthFlag}px`,
                      height: `${heightFlag}px`,
                    }}
                  >
                    <img src={item.lang_flag_base64} alt="" />
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="flags-down-landscape">
          {flags.map((item, index) => {
            const numberOfFlags = Math.round(flags.length / 4);
            // if (index >= (3 * flags.length) / 4 && index < flags.length) {
            if (
              index >= Math.floor(flags.length / 4) + numberOfFlags &&
              index < flags.length - numberOfFlags
            ) {
              const theta = Math.PI / Math.floor(flags.length / 4 + 1);

              const circleRadiusX = height / 2 - height / 8;
              const x =
                circleRadiusX * Math.cos(theta * index + Math.PI / 2) +
                height / 2 -
                heightFlag / 2;

              const y =
                circleRadiusX * Math.sin(theta * index + Math.PI / 2) -
                circleRadiusX / 3;
              // console.log(wrapperWidth);
              // console.log("Element"+index+"has"+ x +"width");
              // console.log("Element"+index+"has"+ y +"height");
              return (
                <div
                  key={item.language_id}
                  className="one-flag-down"
                  id={item.language_id}
                  onClick={() => {
                    clearTimeout(changeFlagInterval.current);
                    handleSelectFlag(item, index);
                  }}
                  style={{
                    top: `${x}px`,
                    left: `${y}px`,
                    width: `${widthFlag}px`,
                    height: `${heightFlag}px`,
                  }}
                >
                  <img src={item.lang_flag_base64} alt="" />
                </div>
              );
            }
          })}
          <div className="flags-down-button-landscape" onClick={addNewLanguage}>
            <Button
              typeButton={typeButton}
              activation={false}
              btnId="language-selection-add-button"
            >
              <img src={Plus} alt="" className="language-selection-img" />
            </Button>
          </div>
        </div>
      </div>
      <div className="languages-footer">
        <div className="leftside-languages-footer" onClick={resetTimer}>
          <span
            style={{ fontSize: `${widthFlag / 2}px`, fontWeight: "600" }}
            className={
              visibilityCounter > 3
                ? "reset-timer-span timer-red"
                : "reset-timer-span"
            }
          >
            {visibilityCounter}
          </span>
          <img src={timerLanguage}></img>
        </div>

        <div
          className="rightside-languages-footer"
          onClick={handleNextSelectLanguage}
        >
          <img src={NextLanguage}></img>
        </div>
      </div>
    </>
  );
};

export default LanguageFlagNew;
